import Vue from 'vue'
import VHotkey from 'v-hotkey'

# additonal keyCodes are required to work, numpad+ and numpad0 contains other codes
# either it's a bug in v-hotkey, or real keyboard's differences
Vue.use VHotkey,
  numpadplus: 107
  numpadzero: 45
